export default "__VITE_ASSET__DDtXe0tY__"